module.exports = __webpack_public_path__ + "static/img/cont44_09.4e310a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont44_09.jpg
// module id = 7tbA
// module chunks = 0